import React from "react";
import { siteConfig as fallback } from "../mock";
import { Icon } from "../lib/icons";
import { useSite } from "../context/SiteContext";

const WhyBuy = () => {
  const { settings } = useSite();
  const items = settings?.whyBuy || fallback.whyBuy;
  return (
    <section id="why" className="bg-navy-800 py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-14">
          <p className="text-gold text-sm font-semibold tracking-widest uppercase mb-3">The Difference</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">Why Buy From Us</h2>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((w, idx) => (
            <div key={idx} className="reveal group bg-navy-700 rounded-2xl p-7 border border-white/10 hover:border-gold/40 transition-colors duration-300" style={{ transitionDelay: `${idx * 40}ms` }}>
              <div className="h-14 w-14 rounded-xl bg-gradient-to-br from-gold-light to-gold-dark flex items-center justify-center text-navy mb-5 group-hover:scale-110 transition-transform duration-300">
                <Icon name={w.icon} size={24} />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{w.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{w.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBuy;
